const HMSOC = () => import('./../views/Social.vue')
const STATS = () => import('./../views/Statisticas.vue')
const VPessoas = () => import('./../views/Pessoas.vue')
const Beneficios = () => import('./../views/Beneficios.vue')
const Remessas = () => import('./../layouts/Remessas.vue')
const Devolucao = () => import('./../layouts/Devolucao.vue')
const Import = () => import('./../views/Retorno.vue')
const ListaBeneficio = () => import('./../relatorios/beneficio.vue')

export default [
  { name: 'viewSocial', path: '/social', component: HMSOC, meta: { acl: true } },
  { name: 'viewStatisticas', path: '/social/statisticas', component: STATS, meta: { acl: true } },
  { name: 'viewVPessoas', path: '/social/pessoas', component: VPessoas, meta: { acl: true } },
  { name: 'viewBeneficios', path: '/social/beneficios', component: Beneficios, meta: { acl: true } },
  { name: 'viewRemessas', path: '/social/layouts/gera-remesas', component: Remessas, meta: { acl: true } },
  { name: 'viewDevolucao', path: '/social/layouts/gera-remesas-de-devolucao', component: Devolucao, meta: { acl: true } },
  { name: 'viewRetorno', path: '/social/layouts/importar-retorno', component: Import, meta: { acl: true } },
  { name: 'viewListaBeneficio', path: '/social/lista-cadastro-de-beneficios', component: ListaBeneficio, meta: { acl: true } }
]
